import React from 'react';
import './App.css';
import { GerichtListRouteComponent } from './features/gerichte/GerichtComponent';
import { ListenListe } from './features/listen/ListenComponent';
import { ZutatenListComponent } from './features/zutaten/ZutatenComponent';
import { Route, Router, Switch } from 'wouter';
import { useHashLocation } from "wouter/use-hash-location"
import { NavLink } from './NavLink';
import { LoginComponent } from './features/auth/Login';

function App() {
  return <Router hook={useHashLocation} >
    <Switch>
      <Route path="/login" component={LoginComponent} />
      <Route>
        <MainNavFrame>
          <Switch>
            <Route path="/gerichte" component={GerichtListRouteComponent} />
            <Route path="/gerichte/**" component={GerichtListRouteComponent} />
            <Route path="/listen" component={ListenListe} />
            <Route path="/listen/**" component={ListenListe} />
            <Route path="/zutaten" component={ZutatenListComponent} />
          </Switch>
        </MainNavFrame>
      </Route>
    </Switch>
  </Router>
}

function MainNavFrame(props: { children?: React.ReactNode }) {
  return <div className="main-nav-frame">
    <ul className="main-nav-header">
      <li><NavLink to="/gerichte">Gerichte</NavLink></li>
      <li><NavLink to="/listen">Listen</NavLink></li>
      <li><NavLink to="/zutaten">Zutaten</NavLink></li>
    </ul>
    <div className="main-nav-content">
      {props.children}
    </div>
  </div>
}

export default App;
